module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "es-mycard-design-preview"
  }, [_c('div', {
    staticClass: "es-mycard-design-preview__controller"
  }, [_c('router-link', {
    staticClass: "es-mycard-design-preview__controller--back-button",
    attrs: {
      "to": "/select_design"
    }
  }, [_c('img', {
    staticClass: "back-button__image",
    attrs: {
      "src": require("../images/arrow_left_brown.png"),
      "alt": "キャンセル"
    }
  }), _c('span', {
    staticClass: "back-button__text"
  }, [_vm._v("キャンセル")])])], 1), _c('div', {
    staticClass: "es_mycard"
  }, [_c('div', {
    staticClass: "es_mycard_background"
  }, [_c('img', {
    attrs: {
      "src": _vm.backgroundImagePath,
      "alt": "背景"
    }
  })]), _vm._m(0), _vm._m(1), _c('div', {
    staticClass: "comment_box"
  }, [_c('div', {
    staticClass: "comment_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.character1ImagePath,
      "alt": "タイラニャン１"
    }
  })]), _c('div', {
    staticClass: "comment_box_body"
  }, [_c('p', {
    staticClass: "comment_box_body-text font_size",
    class: _vm.setClassCommentFontSize
  }, [_vm._v(_vm._s(_vm.comments))])])]), _c('div', {
    staticClass: "created_at"
  }, [_c('p', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.timeStamp)))])]), _c('div', {
    staticClass: "character_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.character2ImagePath,
      "alt": "タイラニャン２"
    }
  })])]), _c('div', {
    staticClass: "es-mycard-design-preview__select-button"
  }, [_c('button', {
    staticClass: "btn01 -home-style -card-write",
    on: {
      "click": function($event) {
        _vm.goSendList()
      }
    }
  }, [_c('span', [_vm._v("このベースデザインにする")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get_user_box"
  }, [_c('div', {
    staticClass: "get_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile_lala.jpg"),
      "alt": "もらう人"
    }
  })]), _c('div', {
    staticClass: "get_user_box_body"
  }, [_c('p', {
    staticClass: "get_user_box_body-role"
  }, [_vm._v("ワンダーエージェント店")]), _c('p', {
    staticClass: "get_user_box_body-name"
  }, [_vm._v("ララ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "give_user_box"
  }, [_c('div', {
    staticClass: "give_user_box_img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_profile_dan.jpg"),
      "alt": "渡す人"
    }
  })]), _c('div', {
    staticClass: "give_user_box_body"
  }, [_c('p', {
    staticClass: "give_user_box_body-role"
  }, [_vm._v("ワンダーエージェント店")]), _c('p', {
    staticClass: "give_user_box_body-name"
  }, [_vm._v("ダン")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3173ff53!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/es-mycard-design-preview.pug
// module id = 1388
// module chunks = 1